import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "全站搜索", to: "/search" },
];

const siteLinks = [
  { label: "首页", to: "/" },
  { label: "关于我们", to: "/about" },
  { label: "版权声明", to: "/about" },
  { label: "联系我们", to: "/about" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center text-white">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-white">高清视频免费观看</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/80 max-w-xs">
              海量高清视频资源在线播放，电影、电视剧、综艺一站看齐，随时随地畅享流畅观影体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-youtube-fill", "ri-mail-line"].map((icon) => (
                <span key={icon} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-primary-100 hover:bg-accent-500 hover:text-white transition-colors cursor-pointer">
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">
              <Link to="/category/movie">内容频道</Link>
            </h4>
            <ul className="space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">
              <Link to="/">网站导航</Link>
            </h4>
            <ul className="space-y-3">
              {siteLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">联系与反馈</h4>
            <ul className="space-y-3 text-sm text-primary-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                support@hqvideo-demo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                400-000-0000（工作日 9:00-18:00）
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区传媒大厦 18 层
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200/70">
          <p>© {year} 高清视频免费观看 · 本站内容均为演示数据，仅供产品展示使用。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            高清画质 · 绿色安全 · 免费观看
          </p>
        </div>
      </div>
    </footer>
  );
}